import './style.css'

import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import {OBJLoader} from 'three/examples/jsm/loaders/OBJLoader.js'
import { MaterialLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { Box3, Texture, Vector3, Vector4 } from 'three'
import ThermoStandardMaterial from './ThermoStandardMaterial'



/**
 * Loaders
 */
const objLoader = new OBJLoader()
const gltfLoader = new GLTFLoader()
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()

const objMaterial = new THREE.MeshPhysicalMaterial()

/**
 * Base
 */
// Debug
const gui = new dat.GUI()
//scene.gui.hide()
const debugObject = {}

// Canvas
const canvas = document.querySelector('canvas.webgl')


// Scene
const scene = new THREE.Scene()

/**
 * Update all materials
 */
const updateAllMaterials = () =>
{
    scene.traverse((child) =>
    {
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        {
            // child.material.envMap = environmentMap
            child.material.envMapIntensity = debugObject.envMapIntensity
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true
        }
    })
}

/**
 * Environment map
 */
const environmentMap = cubeTextureLoader.load([
    './textures/environmentMap/px.jpg',
    './textures/environmentMap/nx.jpg',
    './textures/environmentMap/py.jpg',
    './textures/environmentMap/ny.jpg',
    './textures/environmentMap/pz.jpg',
    './textures/environmentMap/nz.jpg'
])

environmentMap.encoding = THREE.sRGBEncoding

// scene.background = environmentMap
scene.environment = environmentMap

debugObject.envMapIntensity = 1.077
gui.add(debugObject, 'envMapIntensity').min(0).max(4).step(0.001).onChange(updateAllMaterials)

/**
 * Models
 */
//  var frescaColorTexture = new THREE.TextureLoader().load('/models/fresca/fresca_500k_obj/baked_color.jpg')
  var frescaFotoColorTexture = new THREE.TextureLoader().load('./models/fresca/afresco_retopo/afrescoRetopo_colorBaked.jpg') 
  var frescaNormalTexture = new THREE.TextureLoader().load('./models/fresca/afresco_retopo/afrescoRetopo_normalBaked.jpg')
 
  const frescaMaterial = new THREE.MeshStandardMaterial({
//      map: frescaColorTexture,
      normalMap: frescaNormalTexture
  })
 var termoOutput = document.getElementById("termo");
 var termoFile= termoOutput.innerHTML;
 var loader = new THREE.TextureLoader();
 
 loader.load( termoFile, 
 function ( texture ) {    
 
     // The texture has loaded, so assign it to your material object. In the 
     // next render cycle, this material update will be shown on the plane 
     // geometry
     frescaMaterial.map = texture;
     frescaMaterial.needsUpdate = true;
 });

 var texture1= frescaFotoColorTexture;
 
 if (termicCheck){
    var texture2= new THREE.TextureLoader().load(termoFile);
    console.log('termic este bifat')
 }else{
     var texture2= new THREE.TextureLoader().load(termoFile); // nu stiu daca sa incarc o textura goala care sa fie apoi mixata sau nu
     console.log('termic nu este bifat')
 }
 

 var pitchMAterialParams = {
     uniforms: THREE.UniformsUtils.merge([{
         texture1: null,
         texture2: null
     }]),
   
     vertexShader:
    `
    precision highp float;
    precision highp int;
    
    //uniform mat4 modelViewMatrix;
    //uniform mat4 projectionMatrix;
    //attribute vec3 position;
    //attribute vec2 uv;
    varying vec2 vUv;
    
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
    `,
    fragmentShader:
    `
    precision mediump float;
    uniform sampler2D texture1;
    uniform sampler2D texture2;
    varying vec2 vUv;
    
    void main() {
        vec4 t1 = texture2D( texture1, vUv );
        vec4 t2 = texture2D( texture2, vUv );
        gl_FragColor = vec4(mix(t1.rgb, t2.rgb, t2.a), 1.0);
    }
    `
 };

// var sMaterial = new THREE.ShaderMaterial(pitchMAterialParams);
// sMaterial.uniforms.texture1.value= texture1;
// sMaterial.uniforms.texture2.value= texture2;
// sMaterial.normalMap = frescaNormalTexture;
var sMaterial = new ThermoStandardMaterial({});
// sMaterial.uniforms.texture1.value= texture1;
// sMaterial.uniforms.texture2.value= texture2;
sMaterial.normalMap = frescaNormalTexture;
sMaterial.map = texture1

const size = 10;
const divisions = 10;

const gridHelper = new THREE.GridHelper( size, divisions );
scene.add( gridHelper );

/**
 * Sizes
 */
 let dim = document.querySelector("#canvas3D");

 const sizes = {
     width: dim.offsetWidth,
     height: dim.offsetHeight
 }

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
//camera.position.set(6, 4, 14)
camera.position.set(10, 5, 0)
camera.rotation.set(Math.PI/2, 0, Math.PI)
//camera.lookAt(0,5, 0)
//camera.lookAt(scane.frescaModel)

scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
/**
 * GLTF mode - nu vede shader material. so far
 */
// gltfLoader.load(
//     './models/fresca/afresco_retopo/afresco_baking.gltf',
//     (frescaModel) =>
//     {
//         // Model
//         frescaModel.scene.scale.set(1.5, 1.5, 1.5) 
//         frescaModel.scene.rotateY(180*Math.PI/180)
//         scene.add(frescaModel.scene)
//         frescaModel.scene.material = sMaterial;
//         frescaModel.scene.normalMap = frescaNormalTexture;
//         const box = new Box3().setFromObject(frescaModel.scene);
//         controls.target = box.getCenter(new Vector3());
//     }
// )

objLoader.load('./models/fresca/afresco_retopo/afresco_baking.obj',
     (frescaModel)=>
     {
        frescaModel.scale.set(1.5, 1.5, 1.5) 
        frescaModel.rotateY(180*Math.PI/180)
               
        frescaModel.traverse( function ( child ) {

            if ( child instanceof THREE.Mesh ) {
        
                child.material = sMaterial;
                child.normalMap = frescaNormalTexture;
        
            }
        
        } );
        scene.add(frescaModel)
        const box = new Box3().setFromObject(frescaModel);
        controls.target = box.getCenter(new Vector3())
               
     }
)

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3.676)
directionalLight.castShadow = true
directionalLight.shadow.camera.far = 15
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.normalBias = 0.05
directionalLight.position.set(0.274, 3.346, - 2.184)
scene.add(directionalLight)

gui.add(directionalLight, 'intensity').min(0).max(10).step(0.001).name('lightIntensity')
gui.add(directionalLight.position, 'x').min(- 5).max(5).step(0.001).name('lightX')
gui.add(directionalLight.position, 'y').min(- 5).max(5).step(0.001).name('lightY')
gui.add(directionalLight.position, 'z').min(- 5).max(5).step(0.001).name('lightZ')




window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = dim.offsetWidth
    sizes.height = dim.offsetHeight

    // Update camera
    camera.aspect = sizes.height / sizes.width
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.height, sizes.width)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})




/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.CineonToneMapping
renderer.toneMappingExposure = 1.75
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setClearColor('#211d20')
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
let currentTermoFile = null;

slider.onchange = function() {
    //daca plasez aici codul de incarcare a texturii din tick() modificarile apar exclusiv la slider change
    //in tick() se actualizeaza in timp ce trag de slider
    //in slider.change se actualizeaza dupa ce ridic mouse click de pe slider
    //in slider.change tine cont de checker doar la schimbarea pozitiei sliderului
}



const tick = () =>
{
        // Test 
    var testValue= document.getElementById("scala").src;
    var termoOutput = document.getElementById("termo");
    var termoFile= termoOutput.innerHTML;
    // console.log('test: ===>'+testValue);
    // console.log('test2: ===>' + sliderOutput.innerHTML);
    //console.log('test3: ===>' + termoOutput.innerHTML);

    //pentru fresca
    /**
     * Don't do this in the frame update function. Use the span's 'changed' (or whatever it's called) event.
     * This is just a temporary workaround to prevent the application from loading a texture every single frame.
     * You only need to load it when it actually chances not 60 times per second :)
     * Additionally you could cache the texture (in a very simple manner) so that you only really load it once for the entire
     * lifetime of the application
     */
    if(termoFile != currentTermoFile) {
        loader.load( termoFile, 
            function ( texture ) {    
            
                // The texture has loaded, so assign it to your material object. In the 
                // next render cycle, this material update will be shown on the plane 
                // geometry
                //frescaMaterial.map = texture;
                sMaterial.userData.texture2.value = texture;
                sMaterial.needsUpdate = true;
                currentTermoFile = termoFile;
            }
        );
    }
    

    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime // There is clock.getDelta() for this. Just make sure you only call it once per frame.
    previousTime = elapsedTime

    // Update controls
    controls.update()

        // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()